const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.SEMI_PRODUCT)
const groupPrefixDetailed = createApiRoute(ApiModule.DIETARY, ApiDataModel.SEMI_PRODUCT_DETAILED)

export const apiSemiProducts = {
	fetchDietSemiProducts: async (
		filters?: {
			tags: string[] | undefined
			diets: string[] | undefined
			search: string | undefined
			wotStatus?: EDietSemiProductWotStatusFilter | null
		},
		pagination: IApiPagination = { page: 1, perPage: 25 },
	): Promise<{ data: IDietSemiProductModel[]; meta: IApiMetaModel | undefined }> => {
		const { data, meta } = await apiCommon<IDietSemiProduct[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(pagination, {
				name: filters?.search,
				tags: filters?.tags,
				diets: filters?.diets,
				wot_ep_has_mismatch: filters?.wotStatus === EDietSemiProductWotStatusFilter.MISMATCH ? 1 : undefined,
				wot_ep_has_no_production_stages:
					filters?.wotStatus === EDietSemiProductWotStatusFilter.NO_PRODUCTION_STAGES ? 1 : undefined,
			}),
		})

		return { data: data.map(d => DietSemiProduct(d)), meta }
	},
	fetchDietSemiProductDetails: async (id: number): Promise<IDietSemiProductDetailsModel> => {
		const { data } = await apiCommon<IDietSemiProductDetails>(`${groupPrefix}/${id}`, {
			method: 'GET',
		})

		return DietSemiProductDetails(data)
	},
	fetchDietSemiProductDetailsAsArray: async (ids: number[]): Promise<IDietSemiProductDetailsModel[]> => {
		const { data } = await apiCommon<IDietSemiProductDetails[]>(`${groupPrefixDetailed}`, {
			method: 'GET',
			...createQuery(undefined, { id: ids }),
		})

		return data.map(DietSemiProductDetails)
	},
	createDietSemiProduct: async (payload: IDietSemiProductCreatePayload): Promise<IDietSemiProductModel> => {
		const { data } = await apiCommon<IDietSemiProduct>(`${groupPrefix}`, {
			method: 'POST',
			body: payload,
		})

		return DietSemiProduct(data)
	},
	updateDietSemiProduct: async (payload: IDietSemiProductUpdatePayload): Promise<IDietSemiProductModel> => {
		const { data } = await apiCommon<IDietSemiProduct>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		return DietSemiProduct(data)
	},
	deleteDietSemiProduct: async (id: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/${id}`, { method: 'DELETE' })
	},
	duplicateDietSemiProduct: async (id: number): Promise<IDietSemiProductModel> => {
		const { data } = await apiCommon<IDietSemiProduct>(`${groupPrefix}/${id}/duplicate`, { method: 'POST' })

		return DietSemiProduct(data)
	},
	fetchDietSemiProductProductionSteps: async (id: number): Promise<IDietProductionStepModel[]> => {
		const { data } = await apiCommon<IDietProductionStep[]>(`${groupPrefix}/${id}/production-stages`, {
			method: 'GET',
		})

		return data.map(item => DietProductionStep(item))
	},
	fetchDietSemiProductHistory: async (
		id: number,
		search: IApiSearch,
		{ page, perPage = 25 }: IApiPagination,
		filters?: IApiFilters,
	): Promise<IApiResponseModel<IDietaryActivityBusinessEventModel[]>> => {
		const searchFilter = createSearchQuery(search.query, search.type)
		const { data, meta } = await apiCommon<IDietaryActivityBusinessEvent[]>(`${groupPrefix}/${id}/logs`, {
			method: 'GET',
			...createQuery({ page, perPage }, { ...searchFilter, ...filters }),
		})

		return { data: data.map(DietaryActivityBusinessEvent), meta }
	},
	fetchDietSemiProductRelatedMeals: async (id: number): Promise<IDietSemiProductRelatedModel> => {
		const { data } = await apiCommon<IDietSemiProductRelated>(`${groupPrefix}/${id}/related-meals`, {
			method: 'GET',
			params: { with_media: 1 },
		})

		return DietSemiProductRelated(data)
	},
}
